/**
 * LinkedIn Platform Media Restrictions
 * Based on official LinkedIn Posts API specifications
 *
 * @see https://learn.microsoft.com/en-us/linkedin/marketing/community-management/shares/posts-api
 */

export const LINKEDIN_RESTRICTIONS = {
  image: {
    maxFileSize: 10 * 1024 * 1024, // 10 MB
    allowedFormats: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
    minResolution: { width: 552, height: 276 },
    maxResolution: { width: 7680, height: 4320 },
    recommendedAspectRatio: {
      min: 1, // 1:1
      max: 1.91, // 1.91:1
    },
  },
  video: {
    maxFileSize: 5 * 1024 * 1024 * 1024, // 5 GB
    allowedFormats: ['video/mp4', 'video/mov', 'video/webm'],
    minDuration: 3, // seconds
    maxDuration: 600, // 10 minutes
    minResolution: { width: 256, height: 144 },
    maxResolution: { width: 4096, height: 2304 },
    frameRate: {
      min: 10,
      max: 60,
    },
  },
  document: {
    maxFileSize: 100 * 1024 * 1024, // 100 MB
    allowedFormats: ['application/pdf'],
    maxPages: 300,
    // Documents are converted to carousel-style presentation
  },
  multiImage: {
    maxItems: 9, // Max images in multi-image post
    allowedTypes: ['image'], // Only images, no videos in multi-image
  },
  caption: {
    maxLength: 3000, // characters
  },
  general: {
    supportsDocuments: true,
    requiresMedia: false, // Text-only posts are allowed
    maxPostsPerDay: 200,
  },
} as const

export type LinkedInRestrictions = typeof LINKEDIN_RESTRICTIONS
